import { SelectionFieldItem } from './types-fields';
import { GroupByPanelTexts } from './components/group-by-panel-texts';
import { OptionItem } from 'app/components/display-selected-options/display-selected-options';

const getSelectionTypeDesc = (
  { value, selectionTypes: selections }: SelectionFieldItem,
  translation: GroupByPanelTexts
) => {
  const selection = value && selections && selections.find(s => s.type === value.type);

  if (!selection) {
    return '';
  }

  const values: string[] = [];
  if (value.category && selection.categories) {
    const category = selection.categories.find(c => c.value === value.category.value);
    values.push(`${category.description}`);
  }
  if (value.level && selection.levels) {
    const level = selection.levels.find(c => c.value === value.level.value);
    values.push(`${level.description}`);
  }
  if (value.period) {
    const period = selection.periods.find(c => c.value === value.period.value);
    values.push(`${period.description}`);
  }
  if (value.interval) {
    values.push(`${value.interval}`);
  }
  if (value.rollingAverage) {
    values.push(`${translation.group_by_rolling_average}: ${value.rollingAverage}`);
  }
  if (value.fillEmpty) {
    values.push(translation.group_by_missing_values_are_included);
  }

  return selection ? ` (${selection.label}${!!values.length ? ' - ' : ''}${values.join(', ')})` : '';
};

export const getGroupBySelectedOption = (selectedFields: SelectionFieldItem[], translation: GroupByPanelTexts): OptionItem => {

  return {
    value: 'group_by',
    label: translation.group_by_title,
    selections: {
      titles: [],
      values: (selectedFields || []).map(s => (s.field.allLevelDescription || s.field.description) + getSelectionTypeDesc(s, translation)),
      excludedValues: []
    }
  };
};
